import React, { useRef, useState, useEffect, useMemo } from 'react';
import { Canvas, useFrame, useLoader, useThree, extend } from '@react-three/fiber';
import { OrbitControls, Center, useGLTF, useFBO, Environment } from '@react-three/drei';
import useWindowWidth from './useWindowWidth';
import * as THREE from 'three';


export default function Statement( { isMobile } ) {

  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => { }, [isMobile]);

  return (

    <div style={{ 
      position: 'relative',
      width: '100%', 
      height: isMobile ? '70vh' : '80vh',
      marginTop: '-2%',
      overflow: 'hidden',
       display: 'flex',
      justifyContent: 'center',
      marginBottom: isMobile ? '2rem' : '0px'
    }}>

      <div style={{ 
        position: 'absolute',
        top: isMobile ? '-10vh' : '5vh',
        width: '70%', 
        height: '100%',
        zIndex: 1
      }}>

        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          pointerEvents: 'none',
          opacity: isLoaded ? 0 : 0.65,
          transition: 'opacity 1.3s ease'
        }}>
          <p style={{
            fontSize: isMobile ? '1rem' : '1.25rem',
          }}>
            Loading. . .
          </p>
        </div>

      <iframe
        src="https://player.vimeo.com/video/1193420887?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;autoplay=1&amp;muted=1&amp;loop=1&amp;background=1"
        frameBorder="0"
        allow="autoplay; fullscreen;"
        referrerPolicy="strict-origin-when-cross-origin"
        onLoad={() => setIsLoaded(true)}
        style={{
          width: '100%',
          height: '100%',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.5s ease'
        }}
      ></iframe>
        <script src="https://player.vimeo.com/api/player.js"></script>

    </div>
     </div>
  );
}